/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-return-await */
/* eslint-disable consistent-return */
/* eslint-disable no-useless-escape */
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import DialogCommon from "components/dialogCommon";
import RedirectModal from "components/dialogCommon/templates/RedirectModal";
import React, { useEffect, useMemo, useState } from "react";
// @ts-ignore
import { validate } from "react-email-validator";
import { IoIosMail } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { RenderByCargo } from "utils/RenderByCargo";
import { useListarUsuariosCorretores } from "services/api/Identity_Usuario/listar-usuarios-corretores";

import BandeiraCyrela from "../../assets/bandeiras/cyrela.png";
import BandeiraLiving from "../../assets/bandeiras/living.png";
import BandeiraSellit from "../../assets/bandeiras/sellit.png";
import BandeiraVivaz from "../../assets/bandeiras/vivaz.png";
import FrioIcone from "../../assets/icons/frio.svg";
import QuenteIcon from "../../assets/icons/quente.svg";
import NavCommon from "../../components/@navHeader";
import HeaderForm from "../../components/headerForm";
import InputCommon from "../../components/inputCommon";
import SelectComponent from "../../components/selectAutoCompleteG";
import TemperatureSlider from "../../components/temperatureSlider";
import toast from "../../constants/toast";
import axiosLead from "../../services/lead";
import { hubsSocket } from "../../services/socket.IO";
import {
  ColumnIcon,
  Container,
  ContainerTemperature,
  FormControl,
  FormGroupColumn,
  FormGroupRow,
  Space,
  ContainerAutocomplete,
  Label,
} from "./styles";

const NewLead = () => {
  const { usuarioCia, codigoCargo2013 } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);

  const history = useHistory();

  const [bolsao, setBolsao] = useState<boolean>(false);
  const [redirectBolsao, setRedirectBolsao] = useState<boolean>(false);
  const [idLead, setIdLead] = useState<string>("");

  const [temperaturaSelected, setTemperatureSelected] = useState<{
    name: string;
    id: string;
  }>();
  const [temperatura, setTemperatura] = useState<number>(1);
  const [temperatures, setTemperatures] = useState<
    Array<{ id: string; nome: string }>
  >([]);

  const [email, setEmail] = useState<string>("");
  const [emailError, setEmailError] = useState<boolean>(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState<string>("");

  const [name, setName] = useState<string>("");
  const [errorName, setErrorName] = useState<boolean>(false);
  const [errorNameMessage, setErrorNameMessage] = useState<string>("");

  const [phone, setPhone] = useState<string>("");
  const [phoneError, setPhoneError] = useState<boolean>(false);
  const [phoneErrorMessage, setPhoneErrorMessage] = useState<string>("");

  const [originError, setOriginError] = useState<boolean>(false);
  const [origemErrorMessage, setOrigemErrorMessage] = useState<string>("");
  const [origens, setOrigens] = useState<Array<{ id: string; nome: string }>>(
    []
  );
  const [origen, setOrigen] = useState({
    origenSelect: { value: "", label: "" },
  });

  const [initForm, setInitForm] = useState<boolean>(false);

  const [channelError, setChannelError] = useState<boolean>(false);
  const [channelErrorMessage, setChannelErrorMessage] = useState<string>("");
  const [channel, setChannel] = useState({
    channel: { value: "", label: "" },
  });

  const [enterprises, setEnterprises] = useState<
    Array<{ id: string; nome: string; bandeira: string }>
  >([]);

  const [channels, setChannels] = useState<Array<{ id: string; nome: string }>>(
    []
  );
  const [observacao, setObservacao] = useState<string>("");

  const [enterprise, setEnterprise] = useState({
    enterprise: { value: "", label: "", bandeira: "" },
  });

  const [zone, setZone] = useState<any>([]);
  const [zonesMap, setZonesMap] = useState<any>([]);

  const [districts, setDistricts] = useState<
    Array<{ id: string; nome: string; idZonaEmpreendimento: string }>
  >([]);
  const [district, setDistrict] = useState([]);
  const [districtMap, setDistrictMap] = useState<any>([]);

  const [zones, setZones] = useState<Array<{ id: string; nome: string }>>([]);
  const [zonaError, setZonaError] = useState<boolean>(false);
  const [zonaErrorMessage, setZonaErrorMessage] = useState<string>("");

  const [bairroError, setBairroError] = useState<boolean>(false);
  const [bairroErrorMessage, setBairroErrorMessage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const [corretor, setCorretor] = useState<{ label: string; value: string }>({
    label: "",
    value: "",
  });
  const [corretorError, setCorretorError] = useState<boolean>(false);
  const [corretorErrorMessage, setCorretorErrorMessage] = useState<string>("");

  const { data: corretoresData, refetch: refetchCorretores } =
    useListarUsuariosCorretores({
      queryKey: "listar-usuarios-corretores",
    });

  const requestOrigin = async () => {
    try {
      const response = await axiosLead.GetValidOrigin();
      setOrigens(response.data.data);
    } catch (error) {
      toast.wargingError("Erro ao listar origens.");
    }
  };

  const requestEnterprise = async () => {
    try {
      const response = await axiosLead.GetEnterprises();
      const enterprisesData: Array<{
        id: string;
        nome: string;
        bandeira: string;
      }> = response.data.data;
      enterprisesData.push({
        id: "",
        nome: "",
        bandeira: "",
      });
      setEnterprises(response.data.data);
    } catch (error) {
      toast.wargingError("Erro ao listar empreendimentos.");
    }
  };

  const requestTemperature = async () => {
    try {
      const response = await axiosLead.GetTemperature();
      setTemperatures(response.data.data);
      setTemperatureSelected({
        name: response.data.data[0].nome,
        id: response.data.data[0].id,
      });
    } catch (error) {
      toast.wargingError("Erro ao listar temperaturas.");
    }
  };

  const requestZone = async () => {
    try {
      const response = await axiosLead.GetZone();
      setZones(response.data.data);
    } catch (error) {
      toast.wargingError("Erro ao listar zonas.");
    }
  };

  const requestDistrict = async () => {
    try {
      const response = await axiosLead.GetDistricts(zonesMap);
      const { data } = response.data;

      setDistricts(
        data.map(
          (item: {
            nome: string;
            idBairro: string;
            idZonaEmpreendimento: string;
          }) => {
            return {
              nome: item.nome,
              id: item.idBairro,
              idZonaEmpreendimento: item.idZonaEmpreendimento,
            };
          }
        )
      );
    } catch (error) {
      toast.wargingError("Erro ao listar bairros.");
    }
  };

  const requestChannel = async () => {
    try {
      const response = await axiosLead.GetChannelInpt(
        origen.origenSelect.value
      );
      setChannels(response.data.data);
    } catch (error) {
      toast.wargingError("Erro ao listar canais de entrada.");
    }
  };

  const verificationDuplicatePhone = async () => {
    try {
      const response = await axiosLead.GetLeadDuplicatePhone(name, phone);
      // toast.wargingSuccess(response.data.data.message);
      setPhoneError(false);
      setEmailError(false);
    } catch (error: any) {
      if (email.length > 0) {
        setPhoneError(false);
      }
      if (phone.length > 0) {
        setPhoneError(true);
        const mensagemPhone = () => {
          switch (error?.response?.data?.notifications.length) {
            case 1:
              return error?.response?.data?.notifications?.[0].message;
            case 2:
              return error?.response?.data?.notifications?.[0].message;
            case 5:
              return error?.response?.data?.notifications?.[4].message;
            default:
              return "Não foi possível";
          }
        };

        setPhoneErrorMessage(mensagemPhone());
        toast.wargingError(mensagemPhone());
        if (
          error?.response?.data?.notifications?.[3]?.message ===
          "LeadExistenteBolsao"
        ) {
          setRedirectBolsao(true);
          setIdLead(error?.response?.data?.notifications?.[1]?.message);
        }
        if (
          error?.response?.data?.notifications?.[3]?.message ===
          "LeadExistenteCarteiraCorretor"
        ) {
          setIdLead(error?.response?.data?.notifications?.[1]?.message);
        }
      }
      if (phone.length === 0) {
        setPhoneError(false);
      }
    }
  };

  const verificationDuplicateEmail = async () => {
    try {
      const response = await axiosLead.GetLeadDuplicateEmail(name, email);
      // toast.wargingSuccess(response.data.data.message);
      setEmailError(false);
      setPhoneError(false);
    } catch (error: any) {
      if (phone.length > 0) {
        setEmailError(false);
      }
      if (email.length > 0) {
        setEmailError(true);
        const mensagemEmail = () => {
          switch (error?.response?.data?.notifications.length) {
            case 1:
              return error?.response?.data?.notifications?.[0].message;
            case 2:
              return error?.response?.data?.notifications?.[1].message;
            case 5:
              return error?.response?.data?.notifications?.[4].message;
            default:
              return "Não foi possível";
          }
        };
        if (
          error?.response?.data?.notifications?.[3]?.message ===
          "LeadExistenteBolsao"
        ) {
          setRedirectBolsao(true);
          setIdLead(error?.response?.data?.notifications?.[1]?.message);
        }
        if (
          error?.response?.data?.notifications?.[3]?.message ===
          "LeadExistenteCarteiraCorretor"
        ) {
          setIdLead(error?.response?.data?.notifications?.[1]?.message);
        }
        setEmailErrorMessage(mensagemEmail());
        toast.wargingError(mensagemEmail());
      }
    }
  };

  const validation = (): boolean => {
    if (!name) {
      setErrorName(true);
      setErrorNameMessage("Nome é obrigatório.");
    }

    if (!origen.origenSelect.label) {
      setOriginError(true);
      setOrigemErrorMessage("Origem é obrigatório.");
    }

    // Validação para gerente - corretor é obrigatório
    if (codigoCargo2013 === "219.840.001" && !corretor.value) {
      setCorretorError(true);
      setCorretorErrorMessage("Corretor é obrigatório.");
      return true;
    }

    if (zone?.length < 1) {
      setZonaError(true);
      setZonaErrorMessage("Zona é obrigatório caso não haja produto.");
    } else {
      setZonaError(false);
    }

    if (district?.length < 1) {
      setBairroError(true);
      setBairroErrorMessage("Bairro é obrigatório caso não haja produto.");
    } else {
      setBairroError(false);
    }

    if (!phone && email) {
      setPhoneError(false);
    }

    if (!email && !phone) {
      setEmailError(true);
      setPhoneError(true);
      setEmailErrorMessage("Preencher e-mail ou telefone é obrigatório.");
      setPhoneErrorMessage("Preencher e-mail ou telefone é obrigatório.");
    }

    if (email) {
      if (!validate(email)) {
        setEmailError(true);
        setEmailErrorMessage("E-mail inválido.");
      }
    }

    return false;
  };

  const submit = async () => {
    setLoading(true);
    try {
      if (validation()) {
        setLoading(false);
        return false;
      }
      const response = await axiosLead.saveLeadBasic(
        name,
        phone,
        email,
        observacao,
        temperaturaSelected?.id || "",
        origen.origenSelect.value,
        channel.channel.value,
        // @ts-ignore
        enterprise.enterprise.value === "1"
          ? null
          : enterprise.enterprise.value,
        zone?.length > 0 ? zone?.map((item: any) => item.value) : null,
        district.length > 0
          ? district.map((item: { value: string }) => item.value)
          : null,
        codigoCargo2013 === "219.840.001" ? corretor.value : null
      );
      setLoading(false);
      toast.wargingSuccess(
        "Seu cadastro está sendo processado, por favor aguarde."
      );
      if (usuarioCia) {
        history.push({
          pathname: "/menu",
        });
      } else {
        history.push({
          pathname: "/leads",
        });
      }

      return null;
    } catch (error: any) {
      setLoading(false);
      return toast.wargingError(
        `⚠ ${error?.response?.data?.notifications?.map(
          (item: any) => `${item?.message}\n`
        )}`
      );
    }
  };

  const socketLead = useMemo(
    () => hubsSocket.getConnectionHubCadastroLead(),
    []
  );

  useEffect(() => {
    if (!socketLead) {
      return;
    }

    socketLead
      .start()
      .then(() => {
        socketLead.on("CadastroLead", (success, message, dadosCadastro) => {
          console.log("succes", success);
          console.log("message", message);
          console.log("dadosLead", dadosCadastro);
        });
      })
      .catch((e) => {
        console.log("Error socket", e);
      });
    // @ts-ignore
    return () => {
      (async () => await socketLead.stop())();
    };
  }, [socketLead]);

  useEffect(() => {
    if (origen.origenSelect.value) requestChannel();
    setChannel({ channel: { label: "", value: "" } });
    setChannels([]);
  }, [origen.origenSelect]);

  useEffect(() => {
    requestOrigin();
    requestEnterprise();
    requestTemperature();
    requestZone();
    if (codigoCargo2013 === "219.840.001") {
      refetchCorretores();
    }
  }, []);

  useEffect(() => {
    if (name) {
      setErrorName(false);
      setErrorNameMessage("");
    }
    if (channel.channel.value) {
      setChannelError(false);
      setChannelErrorMessage("");
    }
    if (origen.origenSelect.value) {
      setOrigemErrorMessage("");
      setOriginError(false);
    }
    if (corretor.value) {
      setCorretorError(false);
      setCorretorErrorMessage("");
    }
  }, [name, origen.origenSelect, channel.channel, corretor]);

  useEffect(() => {
    if (
      email ||
      name ||
      phone ||
      origen.origenSelect.value ||
      channel.channel.value ||
      observacao ||
      zone?.value ||
      district
    ) {
      setInitForm(true);
    } else {
      setInitForm(false);
    }
  }, [email, name, phone, origen.origenSelect, channel.channel]);

  useEffect(() => {
    // Frio
    if (temperatura < 40) {
      setTemperatureSelected({
        name: temperatures[0]?.nome,
        id: temperatures[0]?.id,
      });
    }
    // Morno
    if (temperatura >= 40 && temperatura < 70) {
      setTemperatureSelected({
        name: temperatures[1]?.nome,
        id: temperatures[1]?.id,
      });
    }
    // Quente
    if (temperatura > 70) {
      setTemperatureSelected({
        name: temperatures[2]?.nome,
        id: temperatures[2]?.id,
      });
    }
  }, [temperatura]);

  const labelProduto = enterprise.enterprise.bandeira;
  const estiloHeader = () => {
    switch (labelProduto) {
      case "CYRELA":
        return {
          primary: "#E82C2A",
          secondary: "#f06966f3",
          bandeira: BandeiraCyrela,
        };
      case "LIVING":
        return {
          primary: "#242C57",
          secondary: "#6A6F8B",
          bandeira: BandeiraLiving,
        };
      case "VIVAZ":
        return {
          primary: "#9A1B71",
          secondary: "#B9699F",
          bandeira: BandeiraVivaz,
        };
      default:
        return {
          primary: "#5882F2",
          secondary: "#61E0AF",
          bandeira: BandeiraSellit,
        };
    }
  };

  useEffect(() => {
    if (enterprise?.enterprise?.value?.length > 0) {
      setDistricts([]);
      setZone([]);
    }
  }, [enterprise]);

  useEffect(() => {
    if (zonesMap?.length < 1) {
      setDistricts([]);
    }
  }, [district]);

  useEffect(() => {
    setDistrictMap(district?.map((item: any) => item?.idZona));
    setZonesMap(zone?.map((item: any) => item?.value));
  }, [zone]);

  useEffect(() => {
    const filteredDistricts = district.filter(function (el: any) {
      let i = 0;
      // eslint-disable-next-line no-plusplus
      for (i = 0; i < zonesMap?.length; i++) {
        if (el.idZona === zonesMap?.[i]) {
          return el;
        }
      }
    });
    if (zonesMap?.length > 0) requestDistrict();
    setDistrict(filteredDistricts);
  }, [zonesMap]);

  return (
    <>
      <NavCommon
        notSave={initForm}
        breadcrumbs={[
          { path: "/leads", name: "Carteira" },
          { path: "", name: "Novo lead" },
        ]}
        showButtonSave
        onBack={() => {
          history.goBack();
        }}
        onSave={() => submit()}
        onChangeActionNew={() => {}}
        loading={loading}
      />
      <Container maxWidth="xl">
        <HeaderForm
          temperature={temperaturaSelected?.name || ""}
          primary={estiloHeader().primary}
          secondary={estiloHeader().secondary}
          children={<></>}
          urlImage={estiloHeader().bandeira}
          nameLead={name}
          emailLead={email}
          phoneLead={phone}
          produto={enterprise.enterprise.label}
        />
        <FormControl>
          <ContainerTemperature>
            <ColumnIcon>
              <img height={24} width={24} src={QuenteIcon} alt="quente" />
              <p>Quente</p>
            </ColumnIcon>
            <TemperatureSlider
              value={temperatura}
              onChange={setTemperatura}
              min={0}
              max={100}
            />

            <ColumnIcon>
              <img height={22} width={22} src={FrioIcone} alt="quente" />
              <p>Frio</p>
            </ColumnIcon>
          </ContainerTemperature>
          <FormGroupColumn>
            <FormGroupColumn>
              <FormGroupRow>
                <Space />
                <InputCommon
                  isDisabled={false}
                  isError={errorName}
                  type="text"
                  maxLengthProps={100}
                  label="Nome *"
                  helperText={errorNameMessage}
                  value={name}
                  onChange={(event: string) => {
                    const nameReg =
                      /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð"  "]*$/;
                    if (nameReg.test(event)) {
                      const arr = event.split(" ");
                      // eslint-disable-next-line no-plusplus
                      for (let i = 0; i < arr.length; i++) {
                        arr[i] =
                          arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
                      }
                      const upperCaseEvent = arr.join(" ");
                      setName(upperCaseEvent);
                    }
                  }}
                />
                <Space />
                <InputCommon
                  isDisabled={false}
                  isError={phoneError}
                  onBlur={() => verificationDuplicatePhone()}
                  type="phone"
                  maxLengthProps={100}
                  label="Telefone *"
                  helperText={phoneErrorMessage}
                  value={phone}
                  onChange={(event: string) => {
                    setPhone(event);
                  }}
                  maskValue="(..) .....-...."
                  idLeadExistente={idLead}
                />
                <Space />
                <InputCommon
                  isDisabled={false}
                  isError={emailError}
                  type="text"
                  onBlur={() => verificationDuplicateEmail()}
                  maxLengthProps={100}
                  icon={<IoIosMail size={20} color="#646363" />}
                  isIconLeft
                  label="E-mail *"
                  helperText={emailErrorMessage}
                  value={email}
                  onChange={(event: string) => {
                    const outString = event.replace(
                      /[`" "~!#$%^&*()|+\=?;:'""",<>\{\}\[\]\\\/]/gi,
                      ""
                    );
                    setEmail(outString.toLowerCase());
                  }}
                  idLeadExistente={idLead}
                />
                <Space />
              </FormGroupRow>
            </FormGroupColumn>
            <FormGroupColumn>
              <FormGroupRow>
                <Space />
                <RenderByCargo
                  cargo={codigoCargo2013}
                  isGerenteVendas={
                    <>
                      <SelectComponent
                        isError={corretorError}
                        value={corretor}
                        label="Corretor *"
                        helperText={corretorErrorMessage}
                        onChange={(ev: { label: string; value: string }) => {
                          setCorretor(ev || { label: "", value: "" });
                        }}
                        data={
                          corretoresData?.data?.map(
                            (item: {
                              apelido: string;
                              idCorretor: string;
                            }) => ({
                              label: item.apelido,
                              value: item.idCorretor,
                            })
                          ) || []
                        }
                      />
                      <Space />
                    </>
                  }
                />
                <SelectComponent
                  isError={originError}
                  value={origen.origenSelect}
                  label="Origem *"
                  helperText={origemErrorMessage}
                  onChange={(ev: { label: string; value: string }) => {
                    setOrigen({ origenSelect: ev || { label: "", value: "" } });
                  }}
                  data={origens?.map((item: { nome: string; id: string }) => ({
                    label: item.nome,
                    value: item.id,
                  }))}
                />
                <Space />
                <SelectComponent
                  isError={channelError}
                  value={channel.channel}
                  label="Canal de contato"
                  helperText={channelErrorMessage}
                  onChange={(ev: { label: string; value: string }) => {
                    setChannel({ channel: ev || { label: "", value: "" } });
                  }}
                  data={channels.map((item: { nome: string; id: string }) => ({
                    label: item.nome,
                    value: item.id,
                  }))}
                />
                <Space />
                <SelectComponent
                  isError={false}
                  placeholder="Sem Produto"
                  value={enterprise.enterprise}
                  label="Produto"
                  helperText="Produto é obrigatório"
                  onChange={(ev: {
                    label: string;
                    value: string;
                    bandeira: string;
                  }) => {
                    setEnterprise({
                      enterprise: ev || { label: "", value: "", bandeira: "" },
                    });
                  }}
                  data={enterprises.map(
                    (item: { nome: string; id: string; bandeira: string }) => ({
                      label: item.nome,
                      value: item.id,
                      bandeira: item.bandeira,
                    })
                  )}
                />
                <Space />
              </FormGroupRow>
            </FormGroupColumn>
            <FormGroupColumn>
              <FormGroupRow style={{ marginLeft: 16, marginRight: 16 }}>
                {enterprise?.enterprise?.value === "" ? (
                  <>
                    <ContainerAutocomplete>
                      <Label color={zonaError ? "red" : "#00000"}>Zona *</Label>
                      <Autocomplete
                        multiple
                        id="checkboxes-tags-demo"
                        options={zones.map(
                          (item: { nome: string; id: string }) => ({
                            label: item.nome,
                            value: item.id,
                          })
                        )}
                        size="small"
                        disableCloseOnSelect
                        filterSelectedOptions
                        value={zone?.zone}
                        getOptionLabel={(option) => option.label || ""}
                        getOptionSelected={(option, value) =>
                          option.label === value.label
                        }
                        onChange={(event, newValue: any) => {
                          setZone(newValue);
                        }}
                        style={{
                          color: zonaError === true ? "red" : "#D0D5DD",
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            error={zonaError}
                            variant="outlined"
                          />
                        )}
                      />
                    </ContainerAutocomplete>
                  </>
                ) : (
                  <></>
                )}
                <Space />
                {enterprise?.enterprise?.value === "" ? (
                  <>
                    <ContainerAutocomplete>
                      <Label color={bairroError ? "red" : "#00000"}>
                        Bairros *
                      </Label>
                      <Autocomplete
                        multiple
                        id="checkboxes-tags-demo"
                        options={districts.map(
                          (item: {
                            nome: string;
                            id: string;
                            idZonaEmpreendimento: string;
                          }) => ({
                            label: item.nome,
                            value: item.id,
                            idZona: item.idZonaEmpreendimento,
                          })
                        )}
                        size="small"
                        disableCloseOnSelect
                        filterSelectedOptions
                        getOptionLabel={(option: { label: string }) =>
                          option.label || ""
                        }
                        getOptionSelected={(option, value) =>
                          option.label === (value as { label: string }).label
                        }
                        value={district}
                        // @ts-ignore
                        onChange={(event: any, value: string | null) => {
                          // @ts-ignore
                          setDistrict(value);
                        }}
                        style={{
                          color: bairroError === true ? "red" : "#D0D5DD",
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder=""
                            error={zonaError}
                            variant="outlined"
                          />
                        )}
                      />
                    </ContainerAutocomplete>
                  </>
                ) : (
                  <></>
                )}
              </FormGroupRow>
            </FormGroupColumn>
            <FormGroupColumn>
              <FormGroupRow>
                <div style={{ width: 18 }} />
                <InputCommon
                  isDisabled={false}
                  isError={false}
                  type="observacao"
                  maxLengthProps={500}
                  label="Observação"
                  value={observacao}
                  row={4}
                  multiline
                  onChange={setObservacao}
                />
                <div style={{ width: 20 }} />
              </FormGroupRow>
            </FormGroupColumn>
            {enterprise?.enterprise?.value !== "1" && (
              <div style={{ paddingBottom: 40 }} />
            )}
          </FormGroupColumn>
        </FormControl>
      </Container>
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => window.location.replace(`/leads/${idLead}`)}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        titleHeader="Atenção!"
        isFilter={false}
        isClose
        width={500}
        component={
          <RedirectModal idLead={idLead} onClose={setBolsao} open={bolsao} />
        }
        setOpenModal={setRedirectBolsao}
        open={redirectBolsao}
      />
    </>
  );
};
export default NewLead;
